import React from 'react';
import ArticleAside from './ArticleAside';
import {i18n_t} from 'app/i18n';

export const Articles = (): React.ReactElement => <>
    <ArticleAside type="news" title={i18n_t('news_title')}/>
    <ArticleAside type="promotions" title={i18n_t('promotions_title')}/>
</>;
